/* SeveralProductsNote: on a delivery, a cargo recap with several products
 * (go-live card 1248h535zfw). The recap's own product, quantity and price
 * boxes are read-only; this delivery's products (which it carries, how much
 * of each, each one's adjusted price) are set in DeliveryProductsTable when
 * the server sends their figures (cargo_products), else listed. Both looks.
 */
import React from 'react';
import { PRICE_DECIMALS, QUANTITY_DECIMALS, formatFigure } from '../../utils/precision';
import DeliveryProductsTable from './DeliveryProductsTable';
import '../DealProductLines.css';

const SeveralProductsNote = ({ recap, side, units = [], deliveryId = null, onSavedFlash, onSaved }) => {
  const lines = Array.isArray(recap?.recap_products) ? recap.recap_products : [];
  const priceKey = side === 'purchase' ? 'buy_price' : 'sale_price';
  // The recap may hold its unit as a code or an id (the screen reads both).
  const stored = recap?.[side === 'purchase' ? 'purchase_contract_quantity_unit' : 'sale_contract_quantity_unit'] || '';
  const match = units.find((u) => u.code === stored || String(u.id) === String(stored));
  const unit = match ? match.code : stored;
  const currency = recap?.[side === 'purchase' ? 'purchase_contract_price_currency' : 'sale_contract_price_currency'] || '';
  if (Array.isArray(recap?.cargo_products) && recap.cargo_products.length > 0) {
    return (
      <DeliveryProductsTable
        deliveryId={deliveryId}
        recap={recap}
        unit={unit}
        currency={currency}
        onSavedFlash={onSavedFlash}
        onSaved={onSaved}
      />
    );
  }
  return (
    <div className="delivery-several-products" role="note">
      <p className="delivery-several-products__lead">
        This deal has several products. Change their quantities and prices on the recap.
      </p>
      {lines.length > 0 && (
        <ul className="delivery-several-products__list">
          {lines.map((line) => (
            <li key={line.id}>
              {line.product_label || 'Product'}
              {line.sale_quantity != null ? ` · ${formatFigure(line.sale_quantity, 0, QUANTITY_DECIMALS)}${unit ? ` ${unit}` : ''}` : ''}
              {line[priceKey] != null ? ` · ${currency ? `${currency} ` : ''}${formatFigure(line[priceKey], 2, PRICE_DECIMALS)}` : ''}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SeveralProductsNote;
